import {
  DolozkaZlucitelnostiFormData,
} from '../model/sprievodnyDokument/dolozkaZlucitelnosti/DolozkaZlucitelnostiFormData';
import { ZlucitelnostSPravomEuEnum }
  from '../model/sprievodnyDokument/dolozkaZlucitelnosti/ZlucitelnostSPravomEuEnum';

const initFormData = (): DolozkaZlucitelnostiFormData => ({
  upravenyVPraveEu: true,
  primarnePravo: '',
  sekundarnePravo: '',
  judikaturaSudnehoDvoraEu: '',
  lehotaPravnyAktEu: '',
  informaciaZacatieKonania: '',
  informaciaPravnePredpisy: '',
  zlucitelnostSPravomEu: ZlucitelnostSPravomEuEnum.CIASTOCNE,
  dovody: '',
});

export default initFormData;
